import { Injectable } from '@angular/core';

@Injectable()
export class ParserService {
  private pattern = '{value}';

  parse<T>(patterns: object, values: object): T {
    const result = new Object() as T;

    for (const key in patterns) {
      if (!patterns.hasOwnProperty(key)) {
        continue;
      }

      const str = patterns[key];

      if (typeof str !== 'string') {
        throw new Error(`In patterns, the value should be a string: ${key}`);
      }

      const match = str.match(new RegExp(`(.*)(${this.pattern})(.*)`));

      if (!match || !(key in values)) {
        result[key] = str;
        continue;
      }

      const particles = Array.from(match).slice(1);
      const index = particles.indexOf(this.pattern);
      particles[index] = String(values[key]);
      result[key] = particles.join('');
    }

    return result;
  }

  changePattern(newPattern: string): void {
    if (!newPattern) {
      throw new Error('Pattern cannot be empty string');
    }

    this.pattern = newPattern;
  }
}
